import React from 'react';
const { useEffect, useState } = React;

import styles from './styles.scss';

import { Modal, AppBar, AppBarTitle, AppBarSection, Button } from '@densityco/ui';
import Mousetrap from 'mousetrap';

import SessionStore from '../../rx-stores/session';
import { SessionStatus } from '../../types/session';
import useRxStore from '../../utils/use-rx-store';

const KeyboardShortcutHelp: React.FunctionComponent<{}> = () => {
  const session = useRxStore(SessionStore);

  // When the `?` key is globally pressed, show a list of all keyboard shortcuts.
  const [open, setOpen] = useState(false);
  useEffect(() => {
    Mousetrap.bind(['?'], () => {
      if (session.status === SessionStatus.LOGGED_IN) {
        setOpen(true);
      }
    });
  }, []);

  // TODO: This is a hack that needs to be upstreamed into density ui in order
  // to properly let the modal open and close without the animation behavior
  // acting weirdly.
  const [openModal, setOpenModal] = useState(true);
  const [renderModal, setRenderModal] = useState(false);
  useEffect(() => {
    let unmounted = false;
    if (open) {
      setRenderModal(true);
      setOpenModal(true);
    } else {
      setOpenModal(false);
      setTimeout(() => {
        if (!unmounted) {
          setRenderModal(false);
        }
      }, 500);
    }

    return () => {
      unmounted = true;
    };
  }, [open]);

  if (!renderModal) {
    return null;
  }

  const mod = navigator.userAgent.includes('Mac') ? '\u2318' : 'ctrl+';

  return (
    <Modal
      visible={openModal}
      onEscape={() => setOpen(false)}
      onBlur={() => setOpen(false)}
    >
      <AppBar>
        <AppBarTitle>Keyboard Shortcuts</AppBarTitle>
        <AppBarSection>
          <Button variant="underline" onClick={() => setOpen(false)}>
            Close
          </Button>
        </AppBarSection>
      </AppBar>

      <div className={styles.wrapper}>
        <section>
          <h3>Global</h3>
          <ul>
            <li>
              <code>?</code> - Open this window
            </li>
          </ul>
        </section>
        <section>
          <h3>Global Search</h3>
          <ul>
            <li>
              <code>{mod}K</code> - Open Global Search
            </li>
            <li>
              <code>&uarr;</code> and <code>&darr;</code> - Move selection up and down
            </li>
            <li>
              <code>Enter</code> - Open selected item
            </li>
            <li>
              <code>{mod}Enter</code> - Open selected item in new tab
            </li>
            <li>
              <code>Esc</code> - Clear the search text
            </li>
          </ul>
        </section>
        <section>
          <h3>Capture Player</h3>
          <ul>
            <li>
              <code>Space</code> - Toggle play / pause
            </li>
            <li>
              <code>&larr;</code> and <code>&rarr;</code> - Move frame by frame
            </li>
            <li>
              <code>Shift+&larr;</code> and <code>Shift+&rarr;</code> - Move by seconds
            </li>
          </ul>
        </section>
      </div>
    </Modal>
  );
};

export default KeyboardShortcutHelp;
